module.exports = __webpack_public_path__ + "img/zazen.41afb90e.png";